import { PropsWithChildren, useEffect, useState } from 'react';

type MountAfterActiveProps = {
  active: boolean;
};

const MountAfterActive = ({
  active,
  children,
}: PropsWithChildren<MountAfterActiveProps>) => {
  const [hasBeenActive, setHasBeenActive] = useState(active);

  useEffect(() => {
    if (active) {
      setHasBeenActive(true);
    }
  }, [active]);

  return active || hasBeenActive ? <>{children}</> : null;
};

export default MountAfterActive;
